"use client";

import { useFormStatus } from "react-dom";
import type { ReactNode } from "react";

export function Spinner({ className = "h-4 w-4" }: { className?: string }) {
  return (
    <svg
      className={`animate-spin ${className}`}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}

// Submit button for server-action forms: flips to a spinner the moment the
// form submits, so the user gets instant feedback that the trigger landed.
// Pass the same classes the plain button had; layout classes are added here.
export function PendingButton({
  children,
  pendingLabel = "Working...",
  className = "",
  disabled,
  title,
  "aria-label": ariaLabel,
}: {
  children: ReactNode;
  pendingLabel?: string;
  className?: string;
  disabled?: boolean;
  title?: string;
  "aria-label"?: string;
}) {
  const { pending } = useFormStatus();
  return (
    <button
      type="submit"
      disabled={disabled || pending}
      title={title}
      aria-label={ariaLabel}
      className={`inline-flex items-center justify-center gap-2 ${className} ${
        pending ? "pointer-events-none opacity-70" : ""
      }`}
    >
      {pending ? (
        <>
          <Spinner />
          {pendingLabel}
        </>
      ) : (
        children
      )}
    </button>
  );
}
